import { Component, OnInit } from '@angular/core';
import { ApiService, CacheService } from 'angular-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../../services/loader.service';

@Component({
    selector: 'ez-password',
    template: require('./password.component.html'),
    styles: [require('./password.component.less')]
})
export class PasswordComponent implements OnInit {
    public processing: boolean = false;
    public oldPassword: string = '';
    public password: string = '';
    public submitButtonDisabled: boolean = false;
    public message: string;
    public typeStatus: string;
    public setFirstPassword: boolean = false;
    public passwordExample: string = '';

    public passwordType: string = 'password';
    public showPassword: boolean = false;

    public rules = [
        {
            name: 'length',
            label: 'account.password-rules.character-number',
            test: function (value) {
                let l = value.length;
                return l >= 8 && l <= 15;
            }
        },
        {
            name: 'uppercase',
            label: 'account.password-rules.uppercase',
            test: function (value) {
                return value.match(/[A-Z]/);
            }
        },
        {
            name: 'lowercase',
            label: 'account.password-rules.lowercase',
            test: function (value) {
                return value.match(/[a-z]/);
            }
        },
        {
            name: 'digit',
            label: 'account.password-rules.digit',
            test: function (value) {
                return value.match(/\d/);
            }
        },
        {
            name: 'symbol',
            label: 'account.password-rules.symbol',
            test: function (value) {
                return value.match(/[@#&"'\(\)\?!\.,;:\/=+\-_\*\$]/);
            }
        }
    ];

    constructor(
        private apiService: ApiService,
        private route: ActivatedRoute,
        private router: Router,
        private loaderService: LoaderService
    ) {
    }

    public ngOnInit() {
        this.apiService.getPasswordExample().subscribe((result) => {
            this.passwordExample = result.example;
        });

        this.route.queryParams.subscribe(params => {
            if (params.cp === '1') {
               this.setFirstPassword = false;
            } else {
                this.setFirstPassword = true;
                // fix if loader doesn't hide when coming from photo upload
                if (this.loaderService.isActive()) {
                    this.loaderService.hide();
                }
            }
        });
    }

    public isValid() {
        for (const rule of this.rules) {
            if (rule.test(this.password) === false) {
                return false;
            }
        }

        return true;
    };

    public submit() {
        this.submitButtonDisabled = true;
        if (this.isValid()) {
            this.loaderService.show();
            this.processing = true;

            this.apiService.savePassword(this.oldPassword, this.password).subscribe(
                (res) => {
                    if (res.result === true) {
                        this.message = res.message;
                        this.typeStatus = 'success';
                        // if password successfully updated and it's the first password setted by user, we redirect to the home
                        if (this.setFirstPassword) {
                            this.router.navigate(['member/home']);
                        }
                    } else {
                        this.message = res.message;
                        this.typeStatus = 'error';
                    }
                    CacheService.remove(CacheService.LOGGED_USER);
                    this.submitButtonDisabled = false;
                    this.loaderService.hide();
                },
                error => {
                    this.loaderService.hide();
                }
            );
        }
    };

    public togglePassword() {
        if (this.showPassword) {
            this.passwordType = 'text';
        } else {
            this.passwordType = 'password';
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/account/password/password.component.ts